<template lang="pug">
  el-row.container(type="flex")
    div.tab(
      v-for="aba in abas"
      @click='changeActive(aba.value)'
    )
      span {{ aba.title }}
      div.line(v-if='activeTab === aba.value')
</template>

<script>

export default {

  props: {
    active: {
      type: String,
      default: 'MUNICIPIOS'
    },
    abas: {
      type: Array,
      required: false,
      default: function () {
        return [{
          title: 'Municípios',
          value: 'MUNICIPIOS'
        },
        {
          title: 'Setor',
          value: 'SETOR'
        },
        {
          title: 'Situação',
          value: 'SITUACAO'
        },
        {
          title: 'Período',
          value: 'PERIODO'
        }]
      }
    }
  },
  data () {
    return {
      activeTab: this.active
    }
  },
  methods: {
    changeActive (aba) {
      this.activeTab = aba
      this.$emit('tabChanged', aba)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/element-variables.scss";
.container {
  width: 100%;
  height: 8vh;
  border-radius: 12px;
  justify-content: space-around;
  align-items: center;
  background-color: white;
  margin-bottom: 3%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.tab {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8%;
  font-size: larger;
  cursor: pointer;
  .line {
    background-color: green;
    height: 5%;
    width: 17vh;
  }
}

@media (max-width: 780px) {
  .container {
    display: flex;
    position: relative;
    height: 90px;
    left: 0 !important;
    align-content: space-around;
  }

  .tab {
    height: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/relatorios/components/AbasGrafico.vue